import { Tags } from "../enum/tags";
import {
  Account,
  BankOption,
  CreateAccountBody,
  ListAccountsParams,
  StoreAccountView,
  UpdateAccountBody,
} from "./dtos/store-bank-account.dto";
import { apiSlice } from "./http";

const STORE_BANK_ACCOUNT_URL = "/store-bank-account";
const STORE_BANK_ACCOUNT_BANKS_URL = `${STORE_BANK_ACCOUNT_URL}/banks`;

interface GetBanksRequest {
  url: string;
  method: "GET";
  params?: { search: string };
}

export function buildGetBanksRequest(search: string | undefined): GetBanksRequest {
  if (search) {
    return { url: STORE_BANK_ACCOUNT_BANKS_URL, method: "GET", params: { search } };
  }
  return { url: STORE_BANK_ACCOUNT_BANKS_URL, method: "GET" };
}

interface ListAccountsRequest {
  url: string;
  method: "GET";
  params: ListAccountsParams;
}

export function buildListAccountsRequest(
  params: ListAccountsParams
): ListAccountsRequest {
  return { url: STORE_BANK_ACCOUNT_URL, method: "GET", params };
}

interface CreateAccountRequest {
  url: string;
  method: "POST";
  body: CreateAccountBody;
}

export function buildCreateAccountRequest(
  body: CreateAccountBody
): CreateAccountRequest {
  return { url: STORE_BANK_ACCOUNT_URL, method: "POST", body };
}

interface UpdateAccountRequest {
  url: string;
  method: "PUT";
  body: UpdateAccountBody;
}

export function buildUpdateAccountRequest(
  body: UpdateAccountBody
): UpdateAccountRequest {
  return { url: STORE_BANK_ACCOUNT_URL, method: "PUT", body };
}

interface StoreViewRequest {
  url: string;
  method: "GET";
}

export function buildStoreViewRequest(storeCode: number): StoreViewRequest {
  return { url: `${STORE_BANK_ACCOUNT_URL}/${storeCode}/store-view`, method: "GET" };
}

export const storeBankAccountApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanks: builder.query<BankOption[], string | undefined>({
      query: buildGetBanksRequest,
    }),
    getStoreBankAccounts: builder.query<Account[], ListAccountsParams>({
      query: buildListAccountsRequest,
      providesTags: [Tags.STORE_BANK_ACCOUNT],
    }),
    createStoreBankAccount: builder.mutation<Account, CreateAccountBody>({
      query: buildCreateAccountRequest,
      invalidatesTags: [Tags.STORE_BANK_ACCOUNT],
    }),
    updateStoreBankAccount: builder.mutation<Account, UpdateAccountBody>({
      query: buildUpdateAccountRequest,
      invalidatesTags: [Tags.STORE_BANK_ACCOUNT],
    }),
    getStoreBankAccountStoreView: builder.query<StoreAccountView[], number>({
      query: buildStoreViewRequest,
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetBanksQuery,
  useGetStoreBankAccountsQuery,
  useCreateStoreBankAccountMutation,
  useUpdateStoreBankAccountMutation,
  useGetStoreBankAccountStoreViewQuery,
} = storeBankAccountApi;
